import { render, staticRenderFns } from "./TeacherScheduleDlg.vue?vue&type=template&id=6064c0e6&scoped=true&"
import script from "./TeacherScheduleDlg.vue?vue&type=script&lang=js&"
export * from "./TeacherScheduleDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064c0e6",
  null
  
)

export default component.exports